/* eslint-disable import/no-extraneous-dependencies */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

const { REACT_APP_I18NEXT_DEBUG } = process.env;

const getUiLanguage = (browserLanguage) => {
  if (browserLanguage.length > 2) {
    return `${browserLanguage.slice(0, 2).toLowerCase()}`;
  }

  return browserLanguage.toLowerCase();
};

const browserLanguage = getUiLanguage(window.navigator.language);

// Versión del build (la inyecta el workflow como github.sha). Se agrega como query (?v=) a la URL
// de cada archivo de traducción para invalidar la caché del navegador en cada deploy: así los
// usuarios ven los textos nuevos sin tener que hacer hard refresh.
const APP_VERSION = process.env.REACT_APP_VERSION || 'dev';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    backend: {
      queryStringParams: { v: APP_VERSION }
    },
    debug: REACT_APP_I18NEXT_DEBUG === 'true',
    fallbackLng: 'es',
    // i18next escapa por defecto `& < > " ' /`, así que una fecha interpolada salía como
    // "27&#x2F;7&#x2F;2026" y un apellido como O'Brien como "O&#39;Brien". Se desactiva porque
    // React ya escapa TODO lo que renderiza como children y ninguna traducción termina en un
    // dangerouslySetInnerHTML (el único del proyecto recibe HTML del editor, no de i18n).
    interpolation: { escapeValue: false },
    lng: browserLanguage,
    load: 'languageOnly',
    // `buttons`, `labels` y `tour` NO estaban precargados y son la causa de fondo de la pantalla
    // que se queda bloqueada: `router/index.js` los pide con `useTranslation`, así que el router
    // ENTERO suspende en cada carga en frío. Y una suspensión POSTERIOR al montaje no desmonta el
    // árbol: React 18 lo oculta con `display:none`. Un elemento oculto así NO ejecuta transiciones
    // CSS ni dispara `transitionend`, de modo que cualquier Fade/Slide de MUI en vuelo se congela
    // y su `onExited` nunca llega — que es como un Drawer acaba dejando su velo puesto para
    // siempre. Precargarlos evita la suspensión y con ella todo lo demás.
    // TODOS los namespaces, sin excepción. La lista corta que hubo aquí dejaba 16 fuera
    // (sessions, payments, nutrition, clients, progress, pqrs…): entrar por primera vez a una de
    // esas pantallas suspendía la aplicación ENTERA, y esa suspensión es la que congelaba el
    // Drawer a mitad de su cierre (reproducido con navegador el 2026-08-17: red lenta + "Mi
    // Programa" en frío = panel zombie con aria-hidden="true" que ya no se quita nunca). Son JSON
    // pequeños que se piden en paralelo al arrancar; mantener la lista corta no ahorraba nada y
    // costaba este bug. Si se crea un namespace nuevo, AÑADIRLO AQUÍ.
    ns: [
      'auth',
      'availabilities',
      'buttons',
      'clients',
      'common',
      'coupons',
      'errors',
      'labels',
      'legal',
      'mealPlans',
      'news',
      'notFound',
      'notifications',
      'nutrition',
      'options',
      'orgClient',
      'organizations',
      'payments',
      'performances',
      'play',
      'pqrs',
      'progress',
      'routes',
      'sessions',
      'tables',
      'tour',
      'validations',
      'wellbeing'
    ],
    supportedLngs: ['es', 'en']
  });

export default i18n;
